import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { getCronTriggerPath } from '~entities/stripe/lib/cron-api-path';
import { baseAPI } from '~shared/api/base-api';

interface TriggerPaymentStateSyncParams {
  isV2: boolean;
}

export const triggerPaymentStateSync = async (
  params: TriggerPaymentStateSyncParams,
) => {
  const response = await baseAPI.post<{ ok?: true }>(
    getCronTriggerPath('payment-state-sync', params.isV2),
  );
  return response.data;
};

export const useTriggerPaymentStateSync = () => {
  return useMutation({
    mutationFn: triggerPaymentStateSync,
    onSuccess: () => {
      toast.success('Payment state sync cron triggered successfully');
    },
    onError: (error: unknown) => {
      const errorMessage =
        error &&
        typeof error === 'object' &&
        'response' in error &&
        error.response &&
        typeof error.response === 'object' &&
        'data' in error.response &&
        error.response.data &&
        typeof error.response.data === 'object' &&
        'message' in error.response.data &&
        typeof error.response.data.message === 'string'
          ? error.response.data.message
          : 'Failed to trigger payment state sync cron.';

      toast.error(errorMessage);
    },
  });
};
